var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNavigationMroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21484 5.21875H10.5273L12.9941 11.7988L15.4551 5.21875H16.7676L13.5098 13.75H12.4668L9.21484 5.21875ZM8.61719 5.21875H9.86523L10.082 10.9141V13.75H8.61719V5.21875ZM16.1172 5.21875H17.3711V13.75H15.9004V10.9141L16.1172 5.21875Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.75H17.5V18.75H8.5V16.75Z",
    fill: "#838383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1.5C7.06294 1.5 2.25 6.31294 2.25 12.25C2.25 18.1871 7.06294 23 13 23C18.9371 23 23.75 18.1871 23.75 12.25C23.75 6.31294 18.9371 1.5 13 1.5ZM0.75 12.25C0.75 5.48451 6.23451 0 13 0C19.7655 0 25.25 5.48451 25.25 12.25C25.25 19.0155 19.7655 24.5 13 24.5C6.23451 24.5 0.75 19.0155 0.75 12.25Z",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigationMroom);
export default __webpack_public_path__ + "static/media/icon-navigation-mroom.a3affaac.svg";
export { ForwardRef as ReactComponent };